import { Component, OnInit } from '@angular/core';
import { TFMService } from 'app/mock-api/tfm.service';
import { Title, Meta } from '@angular/platform-browser';

import { OnboardingType01Component } from './onboarding-type01/onboarding-type01.component';

@Component({
  selector: 'app-onboarding',
  standalone: true,
  imports: [ OnboardingType01Component ],
  templateUrl: './onboarding.component.html',
  styleUrl: './onboarding.component.scss'
})
export class OnboardingComponent implements OnInit {

  public view: any = {
    title: 'Become a Member',
  }

  constructor(private _tfmService: TFMService, private title: Title, private metaService: Meta){}

  ngOnInit(): void {

    this._tfmService.getSite().then(res => {
      this.view.site = res;
      console.log('Site: ', this.view.site);

      if (this.view.site) {
        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        this._tfmService.log(this.view);
      }

    });
      
  }

}
